<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="internship-administrators-management"
            :items="tableData"
            :fields="managerFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-manager"
                    v-b-modal="'add-manager-modal'"
                    type="button"
                    label="add manager"
                    variant="primary">
                    {{ $t('slu_dashboard.add_administrator') }}
                </b-button>
            </template>

            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-remove btn-remove-internship-tag"
                    variant="danger-icon-only"
                    @click="removeManager(data.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-slu-add-manager-modal-component
            :teacher-id-array-in="teacherIdArray"
            ref="add-manager-modal"
            @addManager="addManager($event)">
        </design-2021-slu-add-manager-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-dashboard-managers-tab-component',
    props: ['sluManagersIn'],
    data() {
        return {
            sluManagers: this.sluManagersIn,
            managerFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: 'E-mail',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.sluManagers.map((manager) => {
                return {
                    id: manager.id,
                    name: manager.full_name,
                    email: manager.email,
                };
            });
        },
        teacherIdArray() {
            return this.tableData.map((manager) => manager.id);
        },
    },
    methods: {
        addManager(data) {
            this.sluManagers.push(data);
            this.alert.success();
        },
        removeManager(id) {
            this.alert
                .confirm(
                    this.$t('slu_dashboard.delete_administrator'),
                    this.$t('slu_dashboard.are_you_sure_you_want_to_delete_this_administrator'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.sluManagement(), { data: { teacherId: id } }).then(
                        (response) => {
                            this.sluManagers = this.sluManagers.filter((item) => item.id !== id);
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped></style>
